<template>
  <div class="flex flex-col gap-4">
    <div class="rounded-lg border bg-card p-6">
      <h2 class="text-lg font-semibold">Task Templates</h2>
      <p class="mt-2 text-sm text-muted-foreground">
        Reusable templates that generate concrete tasks.
      </p>
    </div>

    <TaskTemplatesList />
  </div>
</template>

<script setup>
import TaskTemplatesList from "../../components/task-templates/TaskTemplatesList.vue";
</script>
